/**
 * Bepaalt of we bij een maatoptie zelf voorgestelde formaten tonen die niet uit
 * de catalogus komen, maar uit de vrije maat worden afgeleid.
 *
 * Achtergrond: de controle stond eerst inline in `withVirtualCustomSizePresets`
 * in `product-configurator.tsx` en keek alleen of het om de optie `size` ging.
 * Deze module maakt er beleid van, met de leverancier en het bestaande aanbod
 * erbij.
 *
 * De regels, en waarom ze zo zijn:
 *
 * 1. Bij Print.com nooit. Hun catalogus bepaalt zelf welke maten bestaan en
 *    tegen welke prijs; een zelfbedacht formaat erbij verzinnen levert een maat
 *    op die zij niet kennen en die dus niet te prijzen is.
 * 2. Voert een product al vaste formaten naast de vrije maat, dan ook niet.
 *    Die vaste maten zijn de bedoelde keuzes; er nog een reeks bedachte maten
 *    naast zetten maakt de keuze alleen onoverzichtelijk.
 * 3. Blijft over: een product van een andere leverancier dat uitsluitend een
 *    vrije maat heeft. Daar helpt een handvol veelgevraagde formaten de klant
 *    die niet weet wat hij moet invullen.
 */

type OptionValueLike = {
  value?: unknown;
  customSizes?: unknown;
};

type OptionLike = {
  id?: string;
  values?: OptionValueLike[];
};

function isCustomSizeValue(value: OptionValueLike): boolean {
  return Boolean(value?.customSizes) || String(value?.value ?? '') === 'custom';
}

export function shouldOfferVirtualCustomSizePresets(
  option: OptionLike | null | undefined,
  providerType?: string,
): boolean {
  // Bewust terug naar het gedrag dat hiervoor live stond: alleen de optie
  // `size` komt in aanmerking, verder geen beperking.
  //
  // Een parallelle sessie had hier een strenger beleid bedoeld (niet bij
  // Print.com, en niet als er al vaste maten zijn). Dat heeft de opdrachtgever
  // afgewezen: de extra formaatkeuzes zijn met opzet in de winkel gebouwd en
  // verdwenen door dat beleid van alle Print.com-producten tegelijk. Wie het
  // alsnog wil invoeren, stemt dat eerst af; de bijbehorende testverwachtingen
  // staan in het testbestand hiernaast.
  return option?.id === 'size';
}
